import reducre from './reducer'

import deviceTypeListSaga  from '../components/DeviceTypeList/store/saga'
const sagas=[deviceTypeListSaga]
export { reducre,sagas }